import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";

const MobileAppEnableDisableList = (props) => {
  const { addForm } = props;

  // Ensure data is initialized as an empty array
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;

  const { sendRequest: getdepartment } = useHttp();

  const getdepartmentDetail = () => {
    getdepartment(
      {
        url: `/api/serviceDataEditPermission/?orgId=${localStorage.getItem(
          "orgId"
        )}&app_name=Procurement`,
      },
      (res) => {
        console.log("API Response:", res);
        if (res) {
          setData(res);
          setAllData(res);
        } else {
          console.error("Unexpected response format:", res);
        }
      },
      (error) => {
        console.log("Error", error);
      }
    );
  };

  useEffect(() => {
    getdepartmentDetail();
  }, [getdepartment]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  console.log("currentItems", currentItems);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    var filtertext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter((item) =>
      item.empName.toLowerCase().includes(filtertext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              Mobile App Edit Enable/Disable
            </label>
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn btn-primary my-2 mx-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Permissions
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-3">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search by Executive Name"
                          onKeyUp={(e) => handleSearch(e)}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Executive Name</th>
                            <th>Executive ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.empName}</td>
                                <td>{x.employeeCode}</td>
                                {/* <td>
                                  {x.serviceList
                                    .filter((service) => service.status) 
                                    .map((service) => (
                                      <div key={service.serviceId}>
                                        {service.serviceName}
                                      </div>
                                    ))}
                                </td> */}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MobileAppEnableDisableList;
